export default __webpack_public_path__ + "static/media/longchamp13.82566464.jpg";